
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ExpansionPanel from '../../../components/expansion-panel/ExpansionPanel.jsx'
import InformationLine from './InformationLine.jsx'

const ExpansionInformation = ({ title, fields, separator }) => {
  const [isOpened, setIsOpened] = useState(true);
  let isPresentInformation = fields.length !== 0 && fields.some(field => field[1])
  return isPresentInformation && (
    <ExpansionPanel
      onChange={setIsOpened}
      title={title}
      expanded={isOpened}
    >
      {fields.map((field, ii) => (
        <InformationLine key={ii} description={field[0]} value={field[1]} separator={separator} />
      ))}
    </ExpansionPanel>
  )
}

ExpansionInformation.propTypes = {
  title: PropTypes.string.isRequired,
  fields: PropTypes.array,
  separator: PropTypes.string,
};

export default ExpansionInformation
